"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("addSocialButtons", function(leaflet, $timeout, $compile) {
    return {
        restrict : "A",
        require : "obsLeafletMap",
        link : function($scope, $el, $attrs, mapCtrl) {

            var unwatch = $scope.$watch("mapConfig", function(mapConfig) {
                if(mapConfig != null) {
                    unwatch();
                    $timeout(function() {
                        addSocialButtons();
                    }, 1);
                }
            });

            var addSocialButtons = function() {

                mapCtrl.getMap().then(function(map) {
                    var control = leaflet.control({
                        position: "topright"
                    });

                    control.onAdd = function() {
                        var content = $(
                                "<div class='social-buttons'>" +
                                "   <obs-social-linkedin-button></obs-social-linkedin-button>" +
                                "   <obs-social-facebook-button></obs-social-facebook-button>" +
                                "   <obs-social-twitter-button></obs-social-twitter-button>" +
                                "</div>"
                        );
                        $compile(content)($scope);
                        return content[0];
                    };

                    map.addControl(control);
                });
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/social/addSocialButtons.js